var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-news"},_vm._l((_vm.newData),function(item){return _c('product-serie',{key:item.id,attrs:{"productData":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }